module.exports = __webpack_public_path__ + "static/media/arabic.fbe08bfb.jpg";